import { LllNode } from "modules/lll/lll-nodes"
import { LllNodeBranch } from "modules/lll/lll-node-branch"

export class ActivityCounter {

  private _count: number = -1

  constructor(
    private node: LllNode
    , private subject: string) {
  }

  get count(): number {

    if (this._count === -1) {
      this._count = this.doCount(this.node);
    }

    return this._count
  }

  private doCount(node: LllNode): number {

    const subjects = node.subjectName || [];
    const numOfSubjects = subjects.length;

    if(numOfSubjects >= 1 && !node.subjectName?.includes(this.subject)) {
      return 0;
    }

    let count = 0;
    if(node.isActivityGroup()) {
      count += node.activities?.length ?? 0;
    }
    else {
      for(const child of node.getChildren() ?? []) {
        count += this.doCount(child);
      }
    }

    return count;
  }

}
